/**
 * Created by CP.
 */
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

@Injectable()
export class GuestGuard implements CanActivate {
  userType: any;

  constructor(private router: Router) {
    this.userType = JSON.parse(sessionStorage.getItem('currentUser'));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!sessionStorage.getItem('access_token')) {
      // logged in so return true
      return true;
    }

    // this.router.navigate(['/horizontal/food-menu']);
    return false;
  }
}
